import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function ContactSection() {
  return <footer id="footer" className="pt-[80px] sm:pt-[100px] px-5 sm:px-6 md:px-[48px] pb-[48px] sm:pb-[56px] relative overflow-hidden" style={{
    backgroundColor: '#edece6'
  }} data-id="element-8">
      {/* Watermark — bottom right */}
      <div className="absolute -bottom-[30px] -right-[10px] pointer-events-none whitespace-nowrap select-none font-display font-black text-[clamp(120px,18vw,220px)] uppercase tracking-[-0.02em] leading-none" style={{
      color: 'rgba(0,0,0,0.04)'
    }} data-id="element-9">
        LET'S
      </div>

      <div className="max-w-[1200px] relative z-10" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-11">
          {/* Section Label */}
          <div className="font-mono font-light text-[9px] tracking-[0.36em] uppercase text-[#555] flex items-center gap-[16px] mb-[40px] sm:mb-[56px]" data-id="element-12">
            Get Started
            <div className="flex-1 h-[1px] bg-[rgba(0,0,0,0.12)]" data-id="element-13" />
          </div>

          {/* Heading */}
          <h2 className="font-display font-black text-[clamp(40px,8vw,96px)] uppercase tracking-[-0.02em] leading-[0.88] mb-[32px] sm:mb-[44px] max-w-[900px]" data-id="element-14">
            <span className="text-[#0a0a0a]" data-id="element-15">LET'S BUILD</span>
            <br data-id="element-16" />
            <span className="text-[#0a0a0a]" data-id="element-17">SOMETHING</span>
            <br data-id="element-18" />
            <span style={{
            WebkitTextStroke: '1.5px rgba(0,0,0,0.18)',
            color: 'transparent'
          }} data-id="element-19">
              WORTH
            </span>
            <br data-id="element-20" />
            <span style={{
            WebkitTextStroke: '1.5px rgba(0,0,0,0.18)',
            color: 'transparent'
          }} data-id="element-21">
              LOOKING AT.
            </span>
          </h2>

          {/* Body */}
          <p className="font-sans font-light text-[15px] sm:text-[18px] leading-[1.7] text-[#666] max-w-[520px] mb-[48px] sm:mb-[64px]" data-id="element-22">
            Brief us on your next listing. We handle everything — design, copy,
            domain. Live in 48 hours.
          </p>

          {/* CTA Bar */}
          <a href="mailto:hello@vaultlab.agency" className="flex items-center justify-between bg-[#0a0a0a] px-[20px] sm:px-[32px] py-[18px] sm:py-[24px] no-underline mb-[32px] sm:mb-[40px] group transition-colors duration-200 hover:bg-[#111] min-h-[56px]" data-id="element-23">
            <span className="font-mono text-[11px] sm:text-[12px] tracking-[0.22em] uppercase text-tux-lime" data-id="element-24">
              Work With Us
            </span>
            <ArrowRightIcon className="w-5 h-5 text-tux-lime group-hover:translate-x-1 transition-transform duration-200" strokeWidth={1.5} data-id="element-25" />
          </a>

          {/* Email */}
          <div className="flex items-center gap-[16px]" data-id="element-26">
            <div className="w-[20px] h-[1.5px] bg-[#0a0a0a]" data-id="element-27" />
            <a href="mailto:hello@vaultlab.agency" className="font-mono font-light text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-[#333] no-underline transition-colors duration-150 hover:text-[#0a0a0a]" data-id="element-28">
              hello@vaultlab.agency
            </a>
          </div>

          {/* Copyright */}
          <div className="mt-[48px] sm:mt-[64px] pt-[24px] border-t border-[rgba(0,0,0,0.08)]" data-id="element-29">
            <p className="font-mono font-light text-[9px] tracking-[0.2em] uppercase text-[#999]" data-id="element-30">
              © 2025 Vaultlab. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>;
}